const actionDescription = [
  //Login Signup
  {
    name: 'signUpUser',
    docTitle: 'Login/Sign Up Event Action',
    doc: 'The Login/Sign Up event action sets up a login or sign up page with automated sign up and login workflows.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-login-action',
  },
  {
    name: 'signUpUserWithFirebase',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'signUpUserWithXano',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'signUpUserWithBackendless',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'socialLoginSignup',
    docTitle: ' ',
    doc: '',
    docLink: '',
  },
  {
    name: 'loginUser',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'loginUserWithFirebase',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'loginUserWithXano',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'loginUserWithBackendless',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'loginUserWithToken',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'logoutUser',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'sendResetPasswordEmail',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'resetNewPassword',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'signupAndLoginUser',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'signupAndLoginAnonymousUser',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'chnageOldPassword',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'refreshCurrentLoggedInUser',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'refreshCurrentTenant',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  // modal
  {
    name: 'showModal',
    docTitle: 'Modal Event Action',
    doc: 'To set the modal event action, follow the following steps:',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-modal-action',
  },
  {
    name: 'closeModal',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'conditionalOpenModal',
    docTitle: 'Conditional Open Modal',
    doc: 'Allows you to open modal on the basis of the data in session storage of a browser.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-modal-action',
  },
  {
    name: 'conditionalOpenSubpage',
    docTitle: 'Conditional Open Subpage',
    doc: 'Allows you to open subpage on the basis of the data in session storage of a browser.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-modal-action',
  },
  //show hide Section
  {
    name: 'system_show_component',
    docTitle: 'Show/Hide Event',
    doc: 'The Show/Hide action allows you to create the events to Hide and Show a component.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-show-hide-action',
  },
  {
    name: 'system_hide_component',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  //navigation
  {
    name: 'goToPage',
    docTitle: 'Page Redirecting Event',
    doc: 'Page Redirecting Event comes under the Navigation event action. It allows you to redirect users to a different page by a click of a button',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-page-redirecting-action',
  },
  {
    name: 'dynamicPageRedirect',
    docTitle: 'Conditional Page Redirect',
    doc: 'Allows you redirect users on the basis of the data in session storage of a browser.',
    docLink: 'https://academy.drapcode.com/docs/app-event/conditional-redirect-event',
  },
  {
    name: 'customPageRedirect',
    docTitle: 'Custom Page Redirect',
    doc: 'Go to the events panel and click the Add Event button. You will redirected to the add events page.',
    docLink: 'https://academy.drapcode.com/docs/app-event/custom-page-redirect-event-custom-url',
  },
  {
    name: 'reloadPage',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'switchLocalizationLang',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'refreshSection',
    docTitle: 'Refresh Section Event',
    doc: 'Refresh Section Event comes under the Navigation event action. It allows you to create an automated workflow to automatically refreshe a section in which data is either deleted or added',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-refresh-section-action',
  },
  //notification
  {
    name: 'sendDynamicEmail',
    docTitle: 'Dynamic Email Event',
    doc: 'Dynamic Email event comes under the Notification event action. It allows you to create an automated workflow to send an email with a click of a button.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-dynamic-email-action',
  },
  {
    name: 'showAlertMessage',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'showConfirmationMessage',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  //form
  {
    name: 'submitSelectedForm',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'clearBrowserSessionData',
    docTitle: 'Event Action to Clear Browser Session Data',
    doc: 'There could be several scenarios where you want to delete or remove all or specific data that is stored in the browser session (as part of any REST API response or Form Submit). Here you can know how to clear that data via events.',
    docLink:
      'https://academy.drapcode.com/docs/app-event/event-action-to-clear-browser-session-data',
    videoLink: 'https://www.youtube.com/watch?v=QtAb2oP0Xx8',
  },
  {
    name: 'resetFormFields',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  //collection
  {
    name: 'saveCollection',
    docTitle: 'Save Collection Event',
    doc: "The Save Collection event allows you to save data in a collection through an automated workflow. Let's see how to create an event step by step to save data in a collection.",
    docLink: 'https://academy.drapcode.com/docs/app-event/event-save-collection',
  },
  {
    name: 'updateCollection',
    docTitle: 'Update Collection Event',
    doc: 'The collection created in DrapCode can be handled easily by creating collection events. The Update Collection event action allows you to update or change data in a collection.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-update-collection',
  },
  {
    name: 'saveCollectionDraft',
    docTitle: 'Save Collection as Draft Event',
    doc: "The Save Collection as Draft event allows you to save data as a draft in a collection through an automated workflow. Let's see how to create an event step by step to save data in a collection.",
    docLink: 'https://academy.drapcode.com/docs/app-event/event-save-collection',
  },
  {
    name: 'updateCollectionDraft',
    docTitle: 'Update Collection as Draft Event',
    doc: 'The collection created in DrapCode can be handled easily by creating collection events. The Update Collection as Draft event action allows you to update or change data as a draft in a collection.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-update-collection',
  },
  {
    name: 'bulkUpdateCollection',
    docTitle: 'Bulk Update Data',
    doc: 'Bulk Update Data event allows you to make multiple changes or update a bulk of records at once across all selected columns in a data table at once.',
    docLink: 'https://academy.drapcode.com/docs/app-event/bulk-update-event',
  },
  {
    name: 'updateCollectionOnPageLoad',
    docTitle: 'Update Collection Field Values Without Collection Form',
    doc: 'Allow to update the collection field values without using a collection form. There are several scenarios where you may want to update the status of some record, set/unset the value of a boolean field or want to set some pre-defined field value.',
    docLink:
      'https://academy.drapcode.com/docs/app-collection-form/update-collection-field-values-without-collection-form',
  },
  {
    name: 'deleteCollectionItem',
    docTitle: 'Delete Collection Event',
    doc: 'The Delete Collection event allows you to delete data from a collection through an automated workflow. Lets see how to create an event step by step to delete data from a collection through a data table.',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-delete-collection',
  },
  {
    name: 'addToCollectionItem',
    docTitle: 'Add Data Event',
    doc: 'Add data events allow you to create an automatic workflow to add data from a collection with a click of a button.',
    docLink: 'https://academy.drapcode.com/docs/app-event/add-remove-data-action',
  },
  {
    name: 'removeFromCollectionItem',
    docTitle: 'Remove Data Event',
    doc: 'Remove data events allow you to remove data from a collection with a click of a button.',
    docLink: 'https://academy.drapcode.com/docs/app-event/add-remove-data-action',
  },
  {
    name: 'dependentDropDownPopulateOnChange',
    docTitle: 'Dependent Dropdown Event',
    doc: 'A dependent drop-down is a kind of a list whose value is dependent on another value. You can add multiple dependents and therefore, your dependent drop-down can be as long as you want.',
    docLink: 'https://academy.drapcode.com/docs/app-event/dependent-dropdown-collection-event',
  },
  {
    name: 'updateCurrentLoggedInUserData',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'updateCurrentTenantData',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'removeCollectionFieldData',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  //External API
  {
    name: 'sendDataToExternalApi',
    docTitle: 'External API Collection Event',
    doc: 'documentation text comming soon',
    docLink: 'https://academy.drapcode.com/docs/app-event/event-collection-external-api',
  },
  {
    name: 'sendDataToExternalApiAndAuthorize',
    docTitle: 'Save External API Response in User Defined JSON Key',
    doc: "External API (REST API) Response JSON data in user defined/custom JSON key. Use cases could be that a JSON response comes from an API and same type of data comes in another API and you want to save both the responses in the browser session in the custom key of their own. In such cases you won't end up overwriting each others data.",
    docLink:
      'https://academy.drapcode.com/docs/app-event/save-external-api-response-in-user-defined-json-key',
    videoLink: 'https://www.youtube.com/watch?v=REjfFQrjHk8',
  },
  {
    name: 'sendDataToExternalApiAndFileDownload',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'triggerZap',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  // ChatGPT Prompt
  {
    name: 'startNewGptConversation',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  {
    name: 'continueGptConversation',
    docTitle: 'Doc title ',
    doc: 'documentation text',
    docLink: 'documentation link',
  },
  //import/export Data
  {
    name: 'exportCollectionItem',
    docTitle: 'Export Collection Item',
    doc: 'This event allows you to create an automatic workflow to download data of any collection in a CSV file.',
    docLink: 'https://academy.drapcode.com/docs/app-event/export-collection-item-event',
  },
  {
    name: 'importCollectionItem',
    docTitle: 'Import Collection Item',
    doc: 'This event allows you to import or transfer data in CSV format from any device to the database of your web app on DrapCode.',
    docLink: 'https://academy.drapcode.com/docs/app-event/import-collection-item-event',
  },
  {
    name: 'pdfToText',
    docTitle: 'PDF To Text Event',
    doc: 'This event allows you to Convert PDF into text format',
    docLink: 'documentation link',
  },
  {
    name: 'amazonTextract',
    docTitle: 'OCR To Text Event',
    doc: 'This event allows you to Convert OCR into text format',
    docLink: 'documentation link',
  },
  {
    name: 'textAnonymization',
    docTitle: 'Text Anonymization Event',
    doc: 'This event allows you to anonymize words in your text.',
    docLink: 'documentation link',
  },
  {
    name: 'triggerCustomFunction',
    docTitle: 'Execute Custom Functions',
    doc: 'This event allows you to execute your custom function',
    docLink: 'documentation link',
  },
];
export default actionDescription;
